module.exports = __webpack_public_path__ + "static/img/szcy.6d8b85d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szcy.png
// module id = 66K7
// module chunks = 0